const config = {
  graph: {
    host: 'https://api.cloud.property/graph',
  },
  sites: {
    host: 'https://cloud.property',
  },
  sentry: {
    environment: 'production',
  },
  intercom: {
    appId: 'xz3uvyhp',
  },
  stripe: {
    publishableKey: 'pk_live_5V2CIevLzXS0Ld7unxIETNTk00s44pappq',
  },
  features: [
    { featureName: 'GlobalSearchBar', enabled: false },
    { featureName: 'NotificationBell', enabled: false },
    { featureName: 'SupportSection', enabled: false },
    { featureName: 'ActivitySection', enabled: false },
    { featureName: 'BillingBasicFeature', enabled: true },
    { featureName: 'BillingPlusFeature', enabled: true },
    { featureName: 'BillingProFeature', enabled: true },
    { featureName: 'IntegrationsSection', enabled: false },
    { featureName: 'SocialNetworkFBFeature', enabled: false },
    { featureName: 'SocialNetworkInstagramFeature', enabled: false },
    { featureName: 'SocialNetworkTwitterFeature', enabled: false },
    { featureName: 'SocialNetworkLinkedInFeature', enabled: false },
  ],
};
export default config;
